import classNames from 'classnames';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ReactSVGPanZoom, Tool, TOOL_NONE, Value } from 'react-svg-pan-zoom';
import { ProIconButton } from '../../../../atoms/Button/ProIconButton';
import { ProIconDataButtons } from '../../../../atoms/Icons/IconData';
import { ProSwitch } from '../../../../atoms/ProSwitch/ProSwitch';
import { ProTable } from '../../../../atoms/Table/Table';
import { ApplicationElementType, getBaseBCItemForType } from '../../../../components/DetailWindow/breadCrump.helpers';
import { ProPage } from '../../../../components/Page/Page';
import { getBubbleTableData } from '../../../../components/WBSTable/getButtleTableData';
import { ProjectContext } from '../../../../contexts/ProjectContext';
import { WBSContext } from '../../../../contexts/WBSContext';
import { WBSSelectionContext } from '../../../../contexts/WBSSelectionContext';
import { useWBSDetailRouting } from '../../../../hooks/useWBSDetailRouting';
import { Axis, DrawBubble, LimitFrame } from '../../../../modules/Bubbles/Bubbles';
import { proLinkStructure } from '../../../../modules/Menu/Navigate';
import { ProNoDataOrRightsPage } from '../../../../modules/ProErrorPage/NoDataOrRights';
import { ProIntent } from '../../../../utils/enums';
import { usePersonalWBSElemDetailFrame } from '../../../PersonalManagement/WorkPackages/WorkPackage.helpers';
import { getBubbles, INITIAL_VALUE } from './DMMeting.helpers';

export const PMMeetingPage = () => {
    const { t } = useTranslation();
    const [showTree, setShowTree] = useState(true);
    const { selectedElement, selectionMode } = useContext(WBSSelectionContext);
    const { selectedProject, loading, selectedTeam } = useContext(ProjectContext);
    const {
        selectedWBSStructure,
        selectedWBSElement,
        setSelectedWBSElement,
        filteredData,
        openNodes,
        deselectWBSElement,
        tableData,
        setTableData,
        selectedTableRow,
        setSelectedTableRow,
        toggleOpenNode,
        syncWBSScructure,
        setRoute,
        openLowerNodes,
        wbsStructureLoading,
    } = useContext(WBSContext);

    const history = useHistory();

    useEffect(() => {
        setRoute(history.location.pathname);
    }, []);

    // const {
    //     open,
    //     renderWBSDetailWindow,
    //     isDisplayed,
    //     mode: detailWindowMode,
    // } = useWBSDetailWindow('Cost', deselectWBSElement, selectedWBSElement, syncWBSScructure);

    const deselectTableRow = () => {
        deselectWBSElement();
        open('hidden');
    };

    const {
        isDisplayed,
        mode: detailWindowMode,
        open,
        renderDetailWindow,
        sync: detailSync,
    } = usePersonalWBSElemDetailFrame(deselectTableRow, selectedWBSElement?.id, syncWBSScructure);

    useEffect(() => {
        open('hidden');
    }, [selectedWBSStructure]);

    const selectTableRow = (id: number) => {
        if (selectedWBSStructure) {
            setSelectedWBSElement(filteredData![id]);
            open('view');
            setSelectedTableRow(id);
        }
    };

    useEffect(() => {
        const newPosition = filteredData.findIndex((cur) => cur.id === selectedWBSElement?.id);
        newPosition > 0 && selectTableRow(newPosition);
    }, [selectedWBSStructure, filteredData]);

    useEffect(() => {
        setTableData(
            getBubbleTableData({
                detailWindowMode,
                filteredData,
                openNodes,
                selectedWBSStructure,
                toggleOpenNode,
                t,
            })
        );
    }, [selectedWBSStructure, filteredData, isDisplayed, detailWindowMode, selectionMode, selectedElement]);

    const { error: notFoundError, setUrlEmpty } = useWBSDetailRouting({
        path: proLinkStructure.projectManagement.cost.path,
        link: proLinkStructure.projectManagement.cost.link,
        selectedWBSElement,
        filteredData,
        selectTableRow,
        openLowerNodes,
        selectedWBSStructure,
    });

    // Canvas

    const [tool, setTool] = useState<Tool>(TOOL_NONE);
    const [value, setValue] = useState<Value>(INITIAL_VALUE);
    const [bubHover, setBubHover] = useState(false);

    const windowHeight = window.innerHeight - 180;
    const windowWidth = window.innerWidth - 200;

    const Viewer = useRef(null);

    useEffect(() => {
        Viewer?.current && (Viewer.current as any).fitToViewer();
    }, []);

    const setReset = () => {
        setValue(INITIAL_VALUE);
    };

    if (!loading && (!selectedTeam || !selectedProject)) {
        return <ProNoDataOrRightsPage message={[t('error.noData.noTeamOrPortfolio')]} />;
    }

    if (!wbsStructureLoading && notFoundError) return notFoundError;

    return (
        <ProPage
            breadCrump={getBaseBCItemForType(
                [
                    ApplicationElementType.TeamManagement,
                    { type: ApplicationElementType.TeamManagement, name: selectedTeam?.name },
                ],
                t
            )}
            name={'Project management meeting'}
            loading={loading}
            // error={error}
            displayProjectSelector
            filter={
                <>
                    <ProSwitch name="Tree" on={showTree} setOn={setShowTree} />
                    {/* <ProButton
                        text="Show delta 0"
                        tooltip={'Show delta 0'}
                        onClick={() => {
                            setTool('none');
                        }}
                        mainIntent={ProIntent.Secondary}
                        placement="bottom"
                    /> */}
                    <ProIconButton
                        icon={ProIconDataButtons.centerCanvas}
                        tooltip={'Reset canvas'}
                        onClick={setReset}
                        mainIntent={ProIntent.Secondary}
                        placement="bottom"
                    />
                    <ProIconButton
                        icon={ProIconDataButtons.cursor}
                        tooltip={''}
                        onClick={() => {
                            setTool('none');
                        }}
                        mainIntent={tool === 'none' ? ProIntent.Edit : ProIntent.Secondary}
                        placement="bottom"
                    />
                    <ProIconButton
                        icon={ProIconDataButtons.pan}
                        tooltip={'Pan'}
                        onClick={() => {
                            setTool('pan');
                        }}
                        mainIntent={tool === 'pan' ? ProIntent.Edit : ProIntent.Secondary}
                        placement="bottom"
                    />
                </>
            }
        >
            <ReactSVGPanZoom
                width={windowWidth}
                height={windowHeight}
                tool={tool}
                onChangeTool={setTool}
                onChangeValue={setValue}
                ref={Viewer}
                value={value}
                miniatureProps={{ width: 0, height: 0, background: '#fff', position: 'none' }}
                detectAutoPan={false}
                scaleFactorMin={0.8}
                // scaleFactorMax={1.5}
                background="#f9f9fa"
                style={{ position: 'absolute', marginTop: 40 }}
                SVGBackground="#f9f9fa"
                toolbarProps={{ position: 'none' }}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={windowWidth}
                    height={windowHeight}
                    fill="#f9f9fa"
                    className="bubbleCanvas"
                    viewBox={`0 0 ${windowWidth} ${windowHeight}`}
                >
                    <Axis windowHeight={windowHeight} windowWidth={windowWidth} />

                    <g transform={`translate(${windowWidth / 2},${windowHeight / 2})`}>
                        {selectedProject?.projectSetting && (
                            <LimitFrame
                                projectSetting={selectedProject?.projectSetting}
                                windowHeight={windowHeight}
                                windowWidth={windowWidth}
                            />
                        )}
                        {/* <DrawBubble bubble={demoBubble} outHover={bubHover} setOutHover={setBubHover} />
                        <DrawBubble bubble={demoBubble2} outHover={bubHover} setOutHover={setBubHover} /> */}
                        {openNodes.map((cur) => (
                            <DrawBubble
                                bubble={getBubbles(cur)}
                                outHover={bubHover}
                                setOutHover={setBubHover}
                                key={`${cur.id}_bubble`}
                            />
                        ))}
                    </g>
                </svg>
            </ReactSVGPanZoom>
            {showTree && selectedWBSStructure && tableData && (
                <ProTable
                    data={tableData}
                    rowsCount={filteredData?.length ?? 0}
                    selectedTableRow={selectedTableRow}
                    getRowClass={(i) => `ProTable--row__level-${filteredData![i]?.level ?? 0} BubbleTable__Row`}
                    innerClassName="BubbleTable"
                />
            )}

            <div
                className={classNames(
                    'ProApp--detailWindowSection',
                    isDisplayed && 'ProApp--detailWindowSection__expanded'
                )}
            >
                {renderDetailWindow()}
            </div>
        </ProPage>
    );
};
